module.exports = __webpack_public_path__ + "static/img/game-box.feb549fc.png";